import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import PassportImg from '../../assets/images/passport';
import { Link, Paper } from '../Common/Components';

type PropsType = {
  perkLink: string;
};

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'grid',
    placeItems: 'center',
    width: '100%',
    padding: '32px',
    marginTop: '50px',
    maxWidth: 'none',

    [theme.breakpoints.up('sm')]: {
      width: '658px',
    },

    [theme.breakpoints.up('md')]: {
      width: '736px',
    },

    '& a': {
      textDecoration: 'none',
    },
  },
  imageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  content: {
    display: 'grid',
    gridGap: '10px',
    textAlign: 'center',
    width: '100%',
    maxWidth: '251px',
  },
}));

const ProposePassCard: React.FC<PropsType> = ({ perkLink }) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Paper className={classes.container}>
      <div className={classes.content}>
        <Typography variant="subtitle1">Not the Data Pass you want?</Typography>

        <a
          href={perkLink}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.imageWrapper}
        >
          <PassportImg stroke={theme.palette.primary.main} />
        </a>

        <Link href={perkLink} target="_blank" rel="noopener noreferrer" className="wide">
          <b>Propose a new pass here</b>
        </Link>
      </div>
    </Paper>
  );
};

export default ProposePassCard;
